import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ProceduresTableMobile = ({ procedures }) => {
  return (
    <div className="cases-table-mobile">
      {procedures.map((procedure) => {
        return (
          <div key={procedure.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{procedure.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {procedure.flow}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ProceduresTableMobile.propTypes = {
  procedures: PropTypes.array,
};

export default memo(ProceduresTableMobile);
